import { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Loading } from "./Layout";
import { VendorForm } from "../pages/Vendors";
import { X } from "lucide-react";

export function NewLeadModal({ regions, onClose, onCreated }) {
  const [kind, setKind] = useState("client");
  const [meta, setMeta] = useState(null);
  const [f, setF] = useState({ company: "", contact_name: "", title: "", email: "", region: regions[0]?.name || "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/vendor-domains").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  const submit = async () => {
    if (!f.company.trim() || !f.contact_name.trim() || !f.region) { toast.error("Company, contact and region are required"); return; }
    setBusy(true);
    try { await api.post("/leads/quick-add", f); toast.success("Client lead created"); onCreated(); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };
  const inp = "w-full border border-[#DFDAD0] px-3 py-2 text-sm outline-none focus:border-[#1C2530]";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" data-testid="new-lead-modal">
      <div className="bg-white border border-[#DFDAD0] w-full max-w-md p-6 rounded-md">
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">New external contact</div>
            <h3 className="text-lg font-semibold text-[#1C2530] mt-1">Classify contact</h3>
          </div>
          <button onClick={onClose} data-testid="new-lead-close" className="text-[#1C2530]/50 hover:text-[#1C2530]"><X className="w-5 h-5" /></button>
        </div>
        <div className="grid grid-cols-2 gap-2 mb-4">
          <button onClick={() => setKind("client")} data-testid="classify-client"
            className={`px-3 py-2.5 text-sm font-medium border ${kind === "client" ? "bg-[#1C2530] text-[#F5F3EE] border-[#1C2530]" : "border-[#DFDAD0] text-[#1C2530]/70 hover:bg-[#EFECE5]"}`}>
            Client <span className="block font-mono text-[9px] uppercase opacity-70">→ pipeline</span>
          </button>
          <button onClick={() => setKind("vendor")} data-testid="classify-vendor"
            className={`px-3 py-2.5 text-sm font-medium border ${kind === "vendor" ? "bg-[#1C2530] text-[#F5F3EE] border-[#1C2530]" : "border-[#DFDAD0] text-[#1C2530]/70 hover:bg-[#EFECE5]"}`}>
            Vendor <span className="block font-mono text-[9px] uppercase opacity-70">→ directory</span>
          </button>
        </div>
        {kind === "client" ? (
          <>
            <div className="space-y-3">
              <input value={f.company} onChange={(e) => setF({ ...f, company: e.target.value })} placeholder="Company *" data-testid="new-lead-company" className={inp} />
              <input value={f.contact_name} onChange={(e) => setF({ ...f, contact_name: e.target.value })} placeholder="Contact name *" data-testid="new-lead-contact" className={inp} />
              <input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Title" data-testid="new-lead-title" className={inp} />
              <input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email" data-testid="new-lead-email" className={inp} />
              <select value={f.region} onChange={(e) => setF({ ...f, region: e.target.value })} data-testid="new-lead-region" className={inp + " bg-white"}>
                {regions.map((r) => <option key={r.id} value={r.name}>{r.name}</option>)}
              </select>
            </div>
            <button onClick={submit} disabled={busy} data-testid="new-lead-submit" className="mt-4 w-full bg-[#1C2530] text-[#F5F3EE] py-2.5 text-sm font-medium hover:bg-[#2a3644] disabled:opacity-50">
              {busy ? "Creating…" : "Create client lead"}
            </button>
          </>
        ) : (
          meta ? <VendorForm meta={meta} onSaved={onClose} /> : <Loading />
        )}
      </div>
    </div>
  );
}
